export default function SiteFooter() {
  return (
    <footer className="container-kynn pt-10 pb-16">
      <div className="hairline mb-10" />
      <div className="flex flex-col sm:flex-row justify-between gap-6">
        <span className="small-caps" style={{ color: "#E2D3E2", opacity: 0.75 }}>
          © Kynn — 2026
        </span>
        <span
          className="font-scribble"
          style={{ color: "#E2D3E2", fontSize: "22px" }}
          data-testid="footer-signoff"
        >
          by Nana Del Rey
        </span>
      </div>
    </footer>
  );
}
